import {BaseModel} from './baseModel';


export class EntityCount extends BaseModel {

  count: number;

}
